import Helper from "../utils/Helper";

class ApiService {
  constructor() {
    this.helper = new Helper();
    this.header = {
      "Content-Type": "application/json",
    };
  }
  get(url, onResponse, onError, header = null) {
    let that = this;
    let header2 = header ? header : this.header;
    console.log("header is ", header2);
    return fetch(url, {
      method: "GET",
      headers: header ? header : this.header,
    })
      .then(function (response) {
        if (response.status === 204) {
          onResponse("No test readings for today.");
          return;
        }
        if (response.status !== 200) {
          response
            .json()
            .then(function (data) {
              onError(data);
            })
            .catch(function (error) {
              if (onError) {
                onError({
                  message: "Looks like something went wrong. Please try again.",
                });
              }
            });
          return;
        }
        // Examine the text in the response
        response.json().then(function (data) {
          onResponse(data);
          return;
        });
      })
      .catch(function (error) {
        if (that.helper.isJSON(error)) {
          onError(error);
        } else {
          onError({
            message: "Looks like something went wrong. Please try again.",
          });
        }
        return;
      });
  }
  post(url, params, onResponse, onError, header = null) {
    let that = this;

    return fetch(url, {
      method: "POST",
      headers: header ? header : this.header,
      body: JSON.stringify(params),
    })
      .then(function (response) {
        if (response.status === 201) {
          response.json().then(function (data) {
            onResponse(data);
            return true;
          });
          return true;
        }
        if (response.status !== 200) {
          response
            .json()
            .then(function (data) {
              onError(data);
            })
            .catch(function (error) {
              onError({
                message: "Looks like something went wrong. Please try again.",
              });
            });
          return false;
        }

        // Examine the text in the response
        response.json().then(function (data) {
          onResponse(data);
          return;
        });
      })
      .catch(function (error) {
        if (that.helper.isJSON(error)) {
          onError(error);
        } else {
          onError({
            message: "Looks like something went wrong. Please try again.",
          });
        }
        return;
      });
  }
}

export default ApiService;
